import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dead, stateType } from './types';

const initialState: stateType = {
  currentLevel: 1,
  isGame: false,
  isPause: false,
  dead: Dead.NONE,
  isWin: false,
  hasShared: false,
};

export const game = createSlice({
  name: 'game',
  initialState,
  reducers: {
    itIsGame(state) {
      state.isGame = true;
      state.isPause = false;
    },
    setIsPause(state, action: PayloadAction<boolean>) {
      state.isPause = action.payload;
    },
    userWon(state) {
      state.isWin = true;
      state.isGame = false;
    },
    userDead(state, action: PayloadAction<Dead>) {
      state.dead = action.payload;
      state.isWin = false;
      state.isGame = false;
    },
    nextLevel(state) {
      state.isWin = false;
      state.isGame = false;
      state.currentLevel = state.currentLevel + 1;
      state.hasShared = false;
    },
    againLevel(state) {
      state.hasShared = false;
      state.dead = Dead.NONE;
    },
    newGame(state) {
      state.isWin = false;
      state.isGame = false;
      state.currentLevel = 1;
      state.hasShared = false;
    },
    setShared(state, action: PayloadAction<boolean>) {
      state.hasShared = action.payload;
    },
  },
});

export const {
  itIsGame,
  setIsPause,
  userDead,
  userWon,
  nextLevel,
  setShared,
  againLevel,
  newGame,
} = game.actions;

export default game.reducer;
